import {
	login,
	logout,
	getInfo
} from '@/api/login'
import {
	getToken,
	setToken,
	removeToken
} from '@/utils/auth'
import {
	asyncRouterMap,
	constantRouterMap
} from '@/router/index';

const user = {
	state: {
		token: getToken(),
		name: '',
		avatar: '',
		roles: []
	},

	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_NAME: (state, name) => {
			state.name = name
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles
		}
	},

	actions: {
		// 登录
		Login({
			commit
		}, userInfo) {
			const username = userInfo.loginName.trim()
			return new Promise((resolve, reject) => {
				login(username, userInfo.password).then(response => {
					const data = response.data
					const tokenStr = data.token
					setToken(tokenStr)
					commit('SET_TOKEN', tokenStr)
					commit('SET_NAME', data.user.name)
					commit('SET_AVATAR', data.user.headImage)
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 获取用户信息
		GetInfo({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				getInfo().then(response => {
					const data = response.data
					commit('SET_ROLES', asyncRouterMap)
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 登出
		LogOut({
			commit,
			state
		}) {
			commit('SET_TOKEN', '')
			commit('SET_ROLES', [])
			removeToken()
		},

		// 前端 登出
		FedLogOut({
			commit
		}) {
			return new Promise(resolve => {
				commit('SET_TOKEN', '')
				removeToken()
				resolve()
			})
		}
	}
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js